import { StyleProp, ViewStyle } from 'react-native';
import { GeolocationContent } from '@shared/components/Geolocation';
import { GeolocationField } from '@shared/data/entity/fields/GeolocationField';
import { grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: GeolocationField;
  style: StyleProp<ViewStyle>;
}

/*
GeolocationContent
GeolocationMapPreview
*/

const geoStyles: StyleProp<ViewStyle> = {
  paddingVertical: grid(0.25),
};

export function GeolocationCollectionViewField({ field, style }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={[geoStyles, style]}>
      <GeolocationContent showUserName={true} geolocation={field.geolocation} collapsed />
    </CardCollectionViewFieldContainer>
  );
}
